<template>
  <div class="formBuilder">
    <img class="bg-filets" src="/images/altela-img/nos-domaines/bg-filets.png"  alt="bg-filets"/>
    <Breadcrumb level1="Contact" level2="" level3="" />
    <div class="badge-contact d-flex justify-content-evenly mx-5">
      <div class="badge-contact-item">
        <i class="fa-solid fa-location-dot"></i>
        <span class="fw-bold">Adresse</span>
        <div class="info">
          <span>ALTELA, ZI Lasgarrènnes</span> <br/>
          <span>65600 SEMEAC - France</span>
        </div>
      </div>
      <div class="badge-contact-item">
        <i class="fa-solid fa-phone"></i>
        <span class="fw-bold">Téléphone</span>
        <div class="info">
          <span>+33 (0)5 62 33 90 84</span>
        </div>
      </div>
      <div class="badge-contact-item">
        <i class="fa-regular fa-envelope"></i>
        <span class="fw-bold">Email</span>
        <div class="info">
          <span>E-mail: contact@altela.com</span>
        </div>
      </div>
    </div>
    <div class="titleForm">
      Contactez-nous !
    </div>
    <div class="describeContact">
      N’hésitez pas à nous consulter pour toute information, étude et devis gratuits, quels que soient votre domaine d’activité, l’importance et les particularités de votre demande.
    </div>
    <form action="/" method="post" class="form" @submit.prevent="submit">
      <div class="mb-3 divInput">
        <label for="" class="form-label">Société</label>
        <input type="text" class="form-control" placeholder="Votre réponse" v-model="company"/>
      </div>
      <div class="mb-3 divInput">
        <label for="" class="form-label">Secteur d'activité</label>
        <input type="text" class="form-control" placeholder="Votre réponse" v-model="activity" />
      </div>
      <div class="mb-3 divInput">
        <label for="" class="form-label">Nom <span class="required">*</span></label>
        <input type="text" class="form-control" placeholder="Votre réponse" v-model="name" required/>
      </div>
      <div class="mb-3 divInput">
        <label for="" class="form-label">Adresse</label>
        <input type="text" class="form-control" placeholder="Votre réponse" v-model="address" />
      </div>
      <div class="mb-3 divInput">
        <label for="" class="form-label">Code postal</label>
        <input type="text" class="form-control" placeholder="Votre réponse" v-model="zipcode" />
      </div>
      <div class="mb-3 divInput">
        <label for="" class="form-label">Ville</label>
        <input type="text" class="form-control" placeholder="Votre réponse" v-model="city" />
      </div>
      <div class="mb-3 divInput">
        <label for="" class="form-label">Email <span class="required">*</span></label>
        <input type="text" class="form-control" placeholder="Votre réponse" v-model="email" required/>
      </div>
      <div class="mb-3 divInput">
        <label for="" class="form-label">Téléphone <span class="required">*</span></label>
        <input type="text" class="form-control" placeholder="Votre réponse" v-model="phone" required/>
      </div>
      <div class="mb-3 w-100">
        <label for="" class="form-label">Message <span class="required">*</span></label>
        <textarea  class="form-control" placeholder="Votre réponse" v-model="message" required></textarea>
      </div>
      <div class="mb-3 w-100 d-flex flex-column justify-content-center align-items-center gap-3">
        <div id="divRecaptcha">
          <div id="recaptcha" class="g-recaptcha" data-sitekey="6Ld8_KIlAAAAAC_-drK1PJB1fmSD6yQDbr3Uii8Q"></div>
        </div>
        <div class="error" v-show="errorCaptcha">Veuillez valider le captcha !</div>
        <button type="submit" class="btnDecouvrir">
         Envoyer <i class="ms-3 fa-solid fa-arrow-right-long"></i>
        </button>
        <div class="msgSend" v-show="msgSend">Votre méssage a été envoyer ! Merci !</div>
      </div>
    </form>
  </div>
</template>
<script setup lang="ts">
import Breadcrumb from "@/components/altela/Breadcrumb/index.vue"

const errorCaptcha = ref(false)

const name = ref("");
const email = ref("");
const phone = ref("");
const message = ref("");
const company = ref("");
const activity = ref("");
const address = ref("");
const zipcode = ref("");
const city = ref("");

const msgBody = ref("");
const msgSend = ref(false);

const submit = async () => {
  if(!grecaptcha.getResponse()) {
    errorCaptcha.value = true
  } else {
    const token = grecaptcha.getResponse();
    const reponseCaptcha = await useAsyncData(() => $fetch(`/api/verifyCaptcha?secret=6Ld8_KIlAAAAAC93xAz9THC4enRAcZHs4bI_R6_O&response=${token}`));
    if(reponseCaptcha.data.value.success === true) {
      msgBody.value +=  `
          [ALTELA] Vous avez un message depuis votre site web de la part de :<br /><br />
          ${name.value} <br/>
          Email : ${email.value} <br/>
          Téléphone: ${phone.value} <br/>
          Société: ${company.value} <br/>
          Secteur d'activité: ${activity.value} <br/>
          Adresse: ${address.value} <br/>
          Code postal: ${zipcode.value} <br/>
          Ville: ${city.value} <br/>

          Son message: <br/>
          ${message.value}
      `;

      const { data } = await useAsyncData(() => $fetch('https://ws2-gbbu02.graphibox.eu/EpContact.ws', {
        method: 'POST',
        body: {
          pKey: "VrPndaEzxehPS7f63ZEr8vVdK2HtGDfD", // this is an API key for testing purpose only, change this when it is in production
          pType: "web-contact",
          pFct: "SetContact",
          pMsgLastname: `${name.value}`,
          pMsgFirstname: "",
          pMsgPhone: `${phone.value}`,
          pMsgEmail: `${email.value}`,
          pMsgSubject: `Demande de contact`,
          pMsgMessage: `${msgBody.value}`
        }
      }))
      if (data !== undefined) {
        msgSend.value = true
      }
    }
  }
}

let scriptTag;

onMounted(() => {
  setTimeout(() =>{
    var divRecaptcha = document.getElementById("divRecaptcha")
    document.getElementById("recaptcha")?.remove();
    divRecaptcha.innerHTML = `<div id="recaptcha" class="g-recaptcha" data-sitekey="6Ld8_KIlAAAAAC_-drK1PJB1fmSD6yQDbr3Uii8Q"></div>`;
    scriptTag = document.createElement("script");
    scriptTag.setAttribute("src", "https://www.google.com/recaptcha/api.js");
    scriptTag.setAttribute("defer", "");
    scriptTag.setAttribute("async", "");
    document.body.appendChild(scriptTag);
  }, 1000)
})

</script>

<style scoped>
.bg-filets {
  position: absolute;
  top: -30%;
  opacity: 0.1;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
}

.badge-contact-item {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  background-color: #fff;
  padding: 1rem;
  border: 1px solid #DFDFE4;
  border-radius: 10px;
  width: 20%;
  color: #003853;
}

.badge-contact-item i {
  color: #D9000D;
  font-size: 30px;
}

.badge-contact-item .fw-bold {
  color: #003853;
}

.badge-contact-item .info {
  text-decoration: underline;
}

.titleForm {
  font-family: Panton, sans-serif;
  font-size: 33px;
  font-style: italic;
  font-weight: 400;
  line-height: 110%; /* 36.3px */
  letter-spacing: 0.66px;
  text-transform: uppercase;
  color: #003853;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 12px;
}

.describeContact {
  color: #003853;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 145%; /* 23.2px */
  letter-spacing: 0.32px;
}

.form {
  padding: 24px 400px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.form label {
  font-weight: 600;
  color: #003853;
}

.form input,
.form input::placeholder {
  color: #818186;
}

.form .divInput {
  width: 48%;
}

.btnDecouvrir {
  padding: 12px 25px;
  background: #D9000D;
  color: #fff;
  width: auto;
  font-size: 18px;
  text-transform: uppercase;
  border-radius: 5px;
  cursor: pointer;
}

.btnDecouvrir:hover {
  background: #003853;
}

.required, .error {
  color: #D9000D;
}

@media screen and (max-width: 810px) {
  .badge-contact {
    flex-wrap: wrap;
    row-gap: 2rem;
  }

  .badge-contact-item {
    width: auto;
  }

  .form {
    padding: 2rem 1rem;
  }
}

</style>